<template>
    <v-container class="discussion-comment pa-2 py-2" :id="'note-' + note.id">
      <div class="avatar-wrapper pr-2">
        <v-layout column align-center>
          <avatar :size="36" :username="name"></avatar>
          <span v-if="canSeek" class="caption comment-timestamp" @click="jump(note.displayTime)" @keyup.enter="jump(note.displayTime)" tabindex="0"  :aria-label="formatedDuration(note.displayTime) + ' Click to jump to note time'" role="button" >{{formatedDuration(note.displayTime)}}</span>
        </v-layout>
        </div>
      <div class="comment-wrapper">
        <h3 class="comment-name">
          <strong :aria-label="'Note by ' + note.name + ' created ' + fromNow(note.created)">
            {{name}}
            <span class="caption">- {{fromNow(note.created)}}</span>
          </strong>
        </h3>
        <p class="comment-content" v-html="note.text"></p>
        <div class="comment-actions" v-if="editable">
          <span @click="toggleEditNote(note.id)" @keyup.enter="toggleEditNote(note.id)" tabindex="0" aria-label="Open Note Editor" role="button">Edit</span>
          <span @click="deleteNote(note.id)" @keyup.enter="deleteNote(note.id)" tabindex="0" aria-label="delete note" role="button">Delete</span>
        </div>
      </div>
    </v-container>
</template>

<script>
/* global _ */
/* global moment */
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import EventBus from '@/buses/EventBus';
import PlayerService from '@/services/PlayerService';

import _ from 'lodash';
import Avatar from 'vue-avatar';

export default {
  name: 'Note',
  components: {
    Avatar,
  },
  props: [
    'canSeek',
    'editable',
    'note',
  ],
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters('player', [

    ]),
    ...mapGetters('interactions', [

    ]),
    ...mapState('player', [
      'formatedDuration',
    ]),
    name() {
      return `${this.note.firstName} ${this.note.lastName}`
    }
  },
  methods: {
    ...mapMutations('player', [
      'setDesiredState'
    ]),
    deleteNote(noteId) { // should move to vuex
      // if (this.notesPreview) {
      //   // console.log('notes preview delete comment', noteId)
      //   this.notes.splice(_.findIndex(this.notes, { id: noteId }), 1);
      //   if (noteId === this.mode.id && this.mode.type === 'edit') {
      //     // deleted a note that you were editing
      //     this.toggleEditNote(null, false);
      //   }
      //   return;
      // }
      // // this.isProcessingData = true;
      // PlayerService.deleteNote(noteId)
      // .then((response) => {
      //   if (response.data.msg === 'success') {
      //     this.notes = this.notes.filter(n => n.id !== noteId);
      //     if (this.inAutoScrollRange) this.$nextTick(() => this.scrollToBottom())
      //     console.log(noteId, this.mode, noteId === this.mode.id && this.mode.type === 'edit');
      //     if (noteId === this.mode.id && this.mode.type === 'edit') {
      //       // deleted a note that you were editing
      //       this.toggleEditNote(null, false);
      //     }
      //     this.isProcessingData = false;
      //   }
      // })
      // .catch((err) => {
      //   dataLayer.axiosLog(err, 'Notes:deleteNote');
      //   this.isProcessingData = false;
      // })
    },
    fromNow (time) {
      return moment(time).fromNow();
    },
    jump(displayTime) {
      // [ ] move to vuex
      this.setDesiredState('pause');
      EventBus.$emit('requestAction', {
        key: 'seek',
        seekTime: displayTime,
        bypassGates: ['notWithinBounds', 'alreadySeeking']
      });
    },
    toggleEditNote(noteId, open = true) {
      // if (noteId) {
      //   this.lastFocus = document.getElementById(`note-${noteId}`);
      //   this.mode = { type: 'edit', id: noteId}
      //   this.noteInput = _.find(this.notes, {id: noteId}).text
      //   this.$nextTick(() => EventBus.$emit('applyExistingText', 'notes'));
      //   this.showNotesForm = true;
      // }
      // else{
      //   this.mode = {type: 'post', id: 0}
      //   this.noteInput = '';
      //   this.$nextTick(() => {
      //     console.log(this.noteInput);
      //     EventBus.$emit('applyExistingText', 'notes');
      //   })
      //   this.showNotesForm = open
      // }
    },
  },
  watch: {

  },
  mounted() {

  },
};
</script>

<style>

</style>
